import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ThumbUpFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M17.12 7.66C18.52 7.66 19.58 8.9 19.34 10.28L18.32 15C18.14 16.08 17.32 18.84 13.82 18.84H4.8V9.88C7.8 9.52 9.54 7.24 9.54 4.84V3.78C9.54 2.84 10.3 2.08 11.24 2.08C12.18 2.08 12.94 2.84 12.94 3.78V7.66H17.12Z" />
    </SvgIcon>
  );
});
